<template>
  <div class="paragraph">
    <h3 class="title uppercase text-lg font-semibold mx-7">who am i?</h3>
    <br />
    <div class="begin"></div>
    <p class="content font-light text-sm leading-normal mb-4 mx-7">
      Im Gerald U. Ramos, from Camiling Tarlac. I'd like to discover new
      technologies and right now im into mixing geology and machine learning.
      I'm 22 years old and also into travelling specially on two wheels. Looking
      forward to work with you.
    </p>
  </div>
</template>
<script>
export default {
  name: "Presentation",
  setup() {},
};
</script>